<template>

    <div id="sortMenu"
         class="dd-m-menu dd-m-menu--modal dd-m-menu--filter dd-m-filter dd-m-filter--custom dd-m-filter--dropdown">
        <div class="dd-m-menu__container">
            <button type="button" class="dd-m-menu__close-btn">
                <i class="dd-m-icon icon-close"></i>
            </button>

            <div class="dd-m-menu__header dd-m-filter--custom__header">
                <h2 class="dd-m-menu__title dd-m-filter--custom__title">
                    <i class="dd-m-icon icon-sort"></i>
                    Order by
                </h2>

                <span class="dd-m-helper--detail-row"></span>
            </div>

            <div class="dd-m-menu__content dd-m-filter--custom__content">
                <ul class="dd-m-filter--custom__list" v-if="results.length">
                    <li class="dd-m-filter--custom__item"
                        v-for="(item, index) in results"
                        :item="item"
                        :key="index">

                        <input class="dd-m-filter--custom__radio"
                               :id="'check-field-order-'+ index"
                               type="radio"
                               name="sort"
                               :value="item.value"
                               v-model="sort"
                               v-on:change="updateSort(item.name)"/>

                        <label class="dd-m-filter--custom__label"
                               :for="'check-field-order-'+ index">
                            {{item.name}}
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>
<script>
    const bodyScrollLock = require('body-scroll-lock'),
        disableBodyScroll = bodyScrollLock.disableBodyScroll,
        enableBodyScroll = bodyScrollLock.enableBodyScroll;

    export default {
        name: 'card-sort',
        props: [],
        data: () => {
            return {
                sort: '',
                results: [
                    {
                        name: window.Vue.prototype.getTranslateString('Relevance'),
                        value: ''
                    },
                    {
                        name: window.Vue.prototype.getTranslateString('Best sellers'),
                        value: 'bestselling'
                    },
                    {
                        name: window.Vue.prototype.getTranslateString('Top Perfumes'),
                        value: 'top-rated'
                    },
                    {
                        name: window.Vue.prototype.getTranslateString('New'),
                        value: 'new'
                    }
                ]
            }
        },
        mounted() {
            PubSub.subscribe('closeSortMenu', () => this.hide());
            PubSub.subscribe('toggleSortMenu', () => this.toggle());
        },
        methods: {
            toggle: () => {
                $('#sortMenu').fadeToggle('fast', () => {
                    if ($('body').hasClass('is-mobile')) {
                        if ($('#sortMenu').is(":visible")) {
                            disableBodyScroll(document.querySelector('#sortMenu'));
                            $('body').addClass('dd-b-hidden');
                        } else {
                            bodyScrollLock.clearAllBodyScrollLocks();
                            $('body').removeClass('dd-b-hidden');
                        }
                    }
                });
            },
            hide: () => {
                $('#sortMenu').fadeOut('fast');
                bodyScrollLock.clearAllBodyScrollLocks();
                $('body').removeClass('dd-b-hidden');
            },
            updateSort(name) {
                PubSub.publish('updateProductSort', this.sort);
                PubSub.publish('updateSortTitle', name);
                this.hide();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card-sort.vue